import { createContext } from 'react';

export const WindowSizeContext = createContext({
    width : null,
    height: null
});